import React, { useState, useEffect } from 'react'
import "./ChooseHotelForm.css"
import { Hotel, NotFound, TravelerRoom } from '../../../../components'
import { axiosPost } from '../../../../utils/apis/api'
import { SingleCalendar ,SpinnerLoading,ErrorPopUp } from '../../../../components'
import dayjs from "dayjs";
import { Col, Row } from 'react-bootstrap';
import Cookies from 'js-cookie';
import { HotelDetails } from "../../index"
import GlobalModal from '../AddModal/GlobalModal'
import Select from 'react-select';
import { useTranslation } from '../../../../contexts/TranslationContext'
import {getUtcDateWithLocalMidnight} from '../../../../utils/GeneralFunctions'
import hotelsIcon from "../../../../assets/images/packages/svg/hotel.svg";


const ChooseHotelForm = ({ url, onReturn, onHotelSelected, dates, destination, onSuccess, packageId, travelersRooms, nationality }) => {

  const [selectedHotel, setSelectedHotel] = useState(null);
  const [errorPopup, setErrorPopUp] = useState(null);
  const [firstFetch, setFirstFetch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [noHotelMessage, setNoHotelMessage] = useState("");
// const [internalTravelers, setInternalTravelers] = useState(travelersRooms && travelersRooms.length > 0 ? [...travelersRooms] : []);
const [internalTravelers, setInternalTravelers] = useState(
  travelersRooms && travelersRooms.length > 0
    ? travelersRooms.map(item => ({ ...item }))
    : []
);

  const [noRoomsMessage, setNoRoomsMessage] = useState("");
  const [refundable, setRefundable] = useState(false);
  const { t } = useTranslation();
  const [tempCheckInDate, setTempCheckInDate] = useState(dates?.startDate? getUtcDateWithLocalMidnight(new Date (dates?.startDate )): null);
  const [tempEndDate, setTempEndDate] = useState(dates?.endDate?  getUtcDateWithLocalMidnight(new Date (dates?.endDate )) : null);
  const [checkInDate, setCheckInDate] = useState(dates?.startDate || null);
  const [checkOutDate, setCheckOutDate] = useState(dates?.endDate || null);
  const [apiError, setApiError] = useState(null);
  const [errorData, setErrorData] = useState({
    code: "",
    message: "",
    description: ""
  });

  const ratingOptions = [
    { value: 1, label: `1 ${t("Stars")}` },
    { value: 2, label: `2 ${t("Stars")}` },
    { value: 3, label: `3 ${t("Stars")}` },
    { value: 4, label: `4 ${t("Stars")}` },
    { value: 5, label: `5 ${t("Stars")}` },
  ];  
  const [rating, setRating] = useState(ratingOptions[0]);


  const [data, setData] = useState([]);

  const handleShowHotelSelected = (hotel) => {
    setSelectedHotel(hotel); // Store selected hotel
  }


  const handleBackToList = () => {
    setSelectedHotel(null); // Clear selection to show list again
  };

  const start = new Date(`${dates.startDate}`); // add year to make valid date
  const end = new Date(`${dates.endDate}`);

  // Format dates to show only month and day
  const formattedStart = dates?.startDate
    ? dayjs(dates.startDate).format("MMM D")
    : null;

  const formattedEnd = dates?.endDate
    ? dayjs(dates.endDate).format("MMM D")
    : null;

  const diffTime = end - start;
  const nights = Math.round(diffTime / (1000 * 60 * 60 * 24));


  const handleCheckboxChange = (event) => {
    setRefundable(event.target.checked);
  };



  const fetchData = async (pageNumber = 1) => {
    try {
      setNoHotelMessage(null);
      setNoRoomsMessage(null);
      setErrorMessage(null);
      setApiError(null);
      const apiKey = Cookies.get("api_key");
      const apiSecret = Cookies.get("api_secret");
      var headers = {
        Authorization: `token ${apiKey}:${apiSecret}`,
      };
      let payload = {
        check_in: dayjs(checkInDate).format("YYYY-MM-DD"),
        check_out: dayjs(checkOutDate).format("YYYY-MM-DD"),
        rating: rating ? rating.value : 1,
        nationality: nationality ?? "AE",
        refundable: refundable,
        rooms: travelersRooms,
        search_type: destination.location_type.toString().toLowerCase(),
        search_query: destination.location_docname,
      };

      let apiUrl = `${url}/api/method/alltimes.www.hotel_api.search`;
      

      setIsLoading(true);
      const response = await axiosPost(apiUrl, payload, headers);
    
      if (response.data.error) {
        // Handle API errors
        const errorCode = response.data.error.code || "500";
        const errorMsg = response.data.error.message || t("UnknownError");

        setErrorData({
          code: errorCode,
          message: errorMsg,
          description: t("HotelFetchError"),
        });
        setApiError(true);
        setData([]);
      } else {
        // Process successful response
        const result = response.data.result;
  
        setData(result);
      }
    } catch (error) {

      setIsLoading(false);
      const baseMessage = error.message ?? null;
      if (baseMessage != null  && (baseMessage === "No hotels found from the system")) {
        setNoHotelMessage(baseMessage);
      } else if (baseMessage != null  &&( baseMessage === "No Available rooms for given criterin")) {
        setNoRoomsMessage(baseMessage);
      } 
      else if (baseMessage != null){

        // if (
      //   baseMessage.includes("Invalid checkIn date") &&
      //   baseMessage.includes(
      //     "must be greater than or equal to destination's today date"
      //   )
      // ) {
      //   setErrorMessage(baseMessage);
      //   setErrorPopUp(true);
      // } else if (
      //   baseMessage.includes(
      //     "PaxRooms item 0: 'Adults' must be between 1 and 8."
      //   )
      // ) {
        setErrorMessage(baseMessage);
        setErrorPopUp(true);
      } else {
        // Handle other errors
        setErrorData({
          code: error.response?.status,
          message: baseMessage,
          description: t("ConnectionFailed"),
        });
        setApiError(true);
      }

      return { data: null, error: error.message };
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    if (internalTravelers && internalTravelers.length > 0 && internalTravelers[0].Adults && !firstFetch ) {
      setFirstFetch(true);
      fetchData();
    }
  }, [internalTravelers])

useEffect(() => {
  if (!firstFetch && travelersRooms && travelersRooms.length > 0) {
   
    setFirstFetch(true);
  }
}, [travelersRooms]);

  useEffect(() => {
    if (errorMessage) {
      setErrorPopUp(true);
    }
  }, [errorMessage])

  if (isLoading) {
    return (
      <div className='loading-container'>
        <SpinnerLoading />
      </div>
    );
  }
  if (selectedHotel) {
    return (
      <HotelDetails
        url={url}
        hotel={selectedHotel}
        onBack={handleBackToList}
        dates={dates}
        nights={nights}
        onSuccess={onSuccess}
        packageId={packageId}
        selectedDestination={destination}
        //onReturn={onReturn}
        onReturn={()=>{setSelectedHotel(null); }}
      />
    );
  }
  return (
    <div className="choose-hotel-container">
      <button className="hotel-form-backbtn" onClick={onReturn}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          viewBox="0 0 23 23"
          fill="none"
        >
          <path
            d="M5.75 11.5H18.2083M5.75 11.5L9.58333 7.66671M5.75 11.5L9.58333 15.3334"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        {t("BackToPlan")}
      </button>

      <div className="hotel-form-title">
        <div className="hotel-form-title-icon">
          <img src={hotelsIcon} alt="hotel" />
        </div>
        <div>{t("Hotels")}</div>
      </div>

      <div className="hotel-form-dates-nights">
        {`${formattedStart} - ${formattedEnd},  ${nights} ${t("Night")}`}
      </div>
      {/* ${nights !== 1 ? "s" : ""
          } */}
      <Row className="choose-hotel-filters">
        <Col xl={3} md={6} className="mt-4">
          <div className="choose-hotel-input-container">
            <label className="hotel-form-input-label">{t("Rooms")}</label>

            <TravelerRoom
              rooms={internalTravelers}
              onRoomsChange={setInternalTravelers}
              // onRoomsChange={onTravelersRoomsChange}
            />
          </div>
        </Col>
        <Col xl={3} md={6} className="mt-4">
          <div className="choose-hotel-input-container">
            <label className="hotel-form-input-label">{t("Rate")}</label>
            <Select
              options={ratingOptions}
              value={rating}
              placeholder="Select Rating"
              classNamePrefix="custom-select"
              onChange={(selected) => {
                setRating(selected);
              }}
              styles={{
                control: (provided, state) => ({
                  ...provided,
                  border: "0.5px solid #D9D9D9",
                  borderRadius: "5px",
                  backgroundColor: "#FFF",
                  fontSize: "14px",
                  fontFamily: "Dmsans400",
                  padding: "4px 15px",
                  boxShadow: "none",
                  outline: "none",
                  "&:hover": {
                    borderColor: "#D9D9D9",
                  },
                }),

                indicatorSeparator: () => ({
                  display: "none",
                }),

                dropdownIndicator: (provided) => ({
                  ...provided,
                  padding: "6px",
                  color: "#999",
                }),

                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused ? "transparent" : "#FFF",
                  color: "#000",
                  // border: 'none',
                }),

                menu: (provided) => ({
                  ...provided,
                  // border: 'none',
                  // boxShadow: 'none',
                  marginTop: 0,
                }),

                menuList: (provided) => ({
                  ...provided,
                  padding: 0,
                  border: "none",
                }),

                singleValue: (provided) => ({
                  ...provided,
                  color: "#000",
                }),

                placeholder: (provided) => ({
                  ...provided,
                  color: "#999",
                }),
              }}
            />
          </div>
        </Col>

        <Col xl={3} md={6} className="mt-4">
          <div className="choose-hotel-input-container">
            <label className="hotel-form-input-label">{t("CheckInDate")}</label>
            <SingleCalendar
              // value={tempStartDate ? getUtcDateWithLocalMidnight(new Date (tempStartDate)) : startDate? getUtcDateWithLocalMidnight(new Date (startDate)): null}

              value={tempCheckInDate ? new Date(tempCheckInDate) : null}
              onChange={(e) => {
                setTempCheckInDate(e?.value);
              }}
              onHide={() => {
                if (
                  !checkInDate ||
                  dayjs(tempCheckInDate).format("YYYY-MM-DD HH:mm") !==
                    dayjs(checkInDate).format("YYYY-MM-DD HH:mm")
                ) {
                  setCheckInDate(tempCheckInDate);
                }
              }}
              placeholder={
                checkInDate
                  ? dayjs(checkInDate).format("YYYY-MM-DD HH:mm:ss")
                  : t("CheckInDate")
              }
              min={new Date(dates.startDate)}
              max={
                checkOutDate
                  ? new Date(
                      Math.min(
                        new Date(checkOutDate).getTime(),
                        new Date(dates.endDate).getTime()
                      )
                    )
                  : new Date(dates.endDate)
              }
              viewDate={new Date(dates.startDate)}
              className="custom-calendar-input"
              onClearButtonClick={() => {
                setCheckInDate(null);
                setTempCheckInDate(null);
              }}
            />
          </div>
        </Col>

        <Col xl={3} md={6} className="mt-4">
          <div className="choose-hotel-input-container">
            <label className="hotel-form-input-label">
              {t("CheckOutDate")}
            </label>
            <SingleCalendar
              // value={tempEndDate? new Date(tempEndDate): endDate ? getUtcDateWithLocalMidnight(new Date (endDate)) : null}
              value={tempEndDate ? new Date(tempEndDate) : null}
              onChange={(e) => setTempEndDate(e?.value)}
              onHide={() => {
                if (
                  !checkOutDate ||
                  dayjs(tempEndDate).format("YYYY-MM-DD HH:mm") !==
                    dayjs(checkOutDate).format("YYYY-MM-DD HH:mm")
                ) {
                  setCheckOutDate(tempEndDate);
                }
              }}
              min={
                checkInDate
                  ? new Date(
                      Math.max(
                        new Date(checkInDate).getTime(),
                        new Date(dates.startDate).getTime()
                      )
                    )
                  : new Date(dates.startDate)
              }
              max={new Date(dates.endDate)}
              placeholder={
                checkOutDate
                  ? dayjs(checkOutDate).format("YYYY-MM-DD HH:mm:ss")
                  : t("CheckOutDate")
              }
              viewDate={new Date(dates.endDate)}
              className="custom-calendar-input"
              onClearButtonClick={() => {
                setCheckOutDate(null);
                setTempEndDate(null);
              }}
            />
          </div>
        </Col>

        <Col xl={3} md={6} className="mt-3">
          <div className="flight-checkbox">
            <input
              type="checkbox"
              className="flight-checkbox-input"
              checked={refundable}
              onChange={handleCheckboxChange}
            />
            <label className="filght-checkbox-label">{t("Refundable")}</label>
          </div>
        </Col>
        <div className="hotel-search-filter">
          <button
            className={`search-btn`}
            onClick={() => {
              fetchData();
            }}
            disabled={isLoading}
          >
            {t("Search")}
          </button>
        </div>
      </Row>

      <div className="hotels-container">
        {apiError ? (
          <NotFound
            errorCode={errorData.code}
            errorMessage={errorData.message}
            description={errorData.description}
          />
        ) : data && data.length !== 0 ? (
          data.map((hotel) => (
            <Hotel
              onSelect={() => handleShowHotelSelected(hotel)}
              key={hotel?.HotelCode}
              id={hotel?.HotelCode}
              HotelInfo={hotel?.HotelInfo}
              price={hotel?.Rooms[0]?.TotalFare}
              date={hotel?.Rooms[0]?.CancelPolicies[0]?.FromDate}
              // Get first image or use placeholder if none exists
              rate={hotel?.HotelInfo?.HotelRating}
              // onClick={() => handleHotelSelect(hotel)}
            />
          ))
        ) : !isLoading && (noHotelMessage || noRoomsMessage) ? (
          <NotFound
            errorCode={"204"}
            errorMessage={t("NoData")}
            description={
              noHotelMessage
                ? t("NoHotelAvailable")
                : noRoomsMessage
                ? t("NoRoomsAvailable")
                : ""
            }
          />
        ) : null}
      </div>

      <ErrorPopUp
        message={errorMessage}
        showpopUp={errorPopup}
        handleClose={() => {
          setErrorPopUp(false);
          setErrorMessage(null);
        }}
      />

      {/* <GlobalModal
        title={t("Warning")}
        subtitle={errorMessage}
        globalModal={errorPopup}
        onClose={() => {
          setErrorPopUp(false);
          setErrorMessage(null);
        }}
        oneBtnText={t("ok")}
        showOneBtn={true}
        disableClose={true}
      ></GlobalModal> */}
    </div>
  );
}

export default ChooseHotelForm